import { Spinner } from "../shared/spinner"

export default function BlockLoadingFallback() {
  return (
    <section className="m-5 flex h-32 items-center justify-center lg:m-20 2xl:m-24">
      <Spinner />
    </section>
  )
}
